import { Box, Slider, SliderProps } from "@mui/material";

interface IWfSliderProps extends Omit<SliderProps, "onChange"> {
    onChange?: (value: number) => void;
}

const SLIDER_THUMB_SIZE = 20;

export const WfSlider = ({ sx, onChange, ...props }: IWfSliderProps) => {
    const handleChange = (event: Event, value: number | number[]) => {
        if (onChange) {
            const numericValue = Array.isArray(value) ? value[0] : value;
            onChange(numericValue);
        }
    };

    return (
        <Box sx={{ px: "10px", display: "flex" }}>
            <Slider
                {...props}
                onChange={handleChange}
                sx={{
                    "&.MuiSlider-root": {
                        padding: "11px 0",
                    },
                    position: "relative",
                    pointerEvents: "auto",
                    touchAction: "auto",
                    "& .MuiSlider-thumb": {
                        width: `${SLIDER_THUMB_SIZE}px`,
                        height: `${SLIDER_THUMB_SIZE}px`,
                        pointerEvents: "auto",
                        touchAction: "auto",

                        "&:hover, &.Mui-focusVisible": {
                            "@media (hover: none)": {
                                boxShadow: "none",
                            },
                        },
                        "&.Mui-active": {
                            boxShadow: "0 0 0 3px var(--mui-palette-gray-200)",
                            width: "24px",
                            height: "24px",
                        },
                    },
                    "& .MuiSlider-track": {
                        display: "none",
                    },
                    ...sx,
                }}
            />
        </Box>
    );
};
